export const apiField = 'design_life_factor_fc';
export default {
  type: 'Text',
  label: 'DesignLifeFactorFc',
  missing: undefined,
  apiField,
  tooltip: undefined,
};

